import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { ControllerService } from '../shared/services/controller.service';

import { MAT_DATE_LOCALE } from '@angular/material/core';

@Component({
  selector: 'app-shared-reflections',
  templateUrl: './shared-reflections.component.html',
  styleUrls: ['./shared-reflections.component.scss'],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
  standalone: false
})
export class SharedReflectionsComponent implements OnInit {

  data = []
  dataSource: any;
  @ViewChild(MatSort, { static: true }) sort: MatSort = new MatSort();

  submitted = false

  displayedColumns = []

  academicYears = []

  searchForm: any

  clientId: number
  clientName: string = ''
  tagId: number

  columnNames = [
    {
      id: "client",
      value: "Client"
    },
    {
      id: "code",
      value: "Code",
    },
    {
      id: 'description',
      value: 'Description'
    },
    {
      id: 'number_of_submissions',
      value: 'Count'
    }
  ];

  constructor(private controller: ControllerService, private httpService: HttpService, private fb: UntypedFormBuilder, private route: ActivatedRoute
  ) { }


  createSearchForm(fromDate) {
    this.searchForm = this.fb.group({
      fromDate: [fromDate],
      toDate: [],
    })
  }

  get f() {
    return this.searchForm.controls
  }

  // Format a Date to YYYY-MM-DD using local components.
  // Avoids toISOString(), which converts to UTC and can roll the date
  // back a day when the local timezone is ahead of UTC (e.g. BST).
  private toLocalDateString(value: any): any {
    if (value instanceof Date) {
      return [
        value.getFullYear(),
        String(value.getMonth() + 1).padStart(2, '0'),
        String(value.getDate()).padStart(2, '0')
      ].join('-');
    }
    return value;
  }


  async onSubmit() {
    const formModel = this.searchForm.value;

    this.submitted = true
    if (this.searchForm.invalid) {
      return
    }

    const fromDate = this.toLocalDateString(formModel.fromDate);
    const toDate = this.toLocalDateString(formModel.toDate);

    await this.fetchData(fromDate, toDate)

    this.submitted = false
  }

  skeletonRows: number[][] = [];
  loading = false;

  generateSkeletonRows() {
    this.skeletonRows = Array(10).fill(0).map(() => {
      // Random number of bars between 5 and 8 to ensure density
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        // Random flex weight between 1 and 10 to give variety in width
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });
  }

  async fetchData(fromDate, toDate) {

    this.data = []
    this.dataSource.data = []

    this.loading = true;
    this.generateSkeletonRows();


    try {
      const response: any = await this.httpService.postAsync('report/reflections', { fromDate, toDate, clientId: this.clientId, tagId: this.tagId })

      if (!response.success) {
        alert("Error communicating with server.")
        return
      }
      this.data = response.data

      this.dataSource.data = this.data
    } finally {
      this.loading = false
    }

  }

  async downloadFeedback() {
    const fromDate = this.toLocalDateString(this.searchForm.value.fromDate)
    const toDate = this.toLocalDateString(this.searchForm.value.toDate)

    if (!fromDate && !this.clientId && !this.tagId) {
      alert("You must set a from date.")
      return
    }

    const downloadUrl = this.clientId > 0 ? await this.controller.getDownloadFeedbackUrl(this.clientId) : await this.controller.getDownloadFeedbackAllUrl()

    // this.loading = true; // Optional: Show loading state during download preparation

    let qs = ''
    if (fromDate) {
      qs += '&fromDate=' + fromDate
    }
    if (toDate) {
      qs += '&toDate=' + toDate
    }
    if (this.tagId) {
      qs += '&tagId=' + this.tagId
    }

    try {
      const blob: any = await this.httpService.getBlob(downloadUrl + qs)


      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${this.clientName}-${fromDate}-feedback.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } finally {
      // this.loading = false;
    }
    return false
  }


  async downloadReflections() {

    const fromDate = this.toLocalDateString(this.searchForm.value.fromDate)
    const toDate = this.toLocalDateString(this.searchForm.value.toDate)

    let qs = ''
    if (fromDate) {
      qs += '&fromDate=' + fromDate
    }
    if (toDate) {
      qs += '&toDate=' + toDate
    }

    // build url with query fromDate and clientId
    if (this.clientId) {
      qs += '&clientId=' + this.clientId
    }
    if (this.tagId) {
      qs += '&tagId=' + this.tagId
    }

    try {
      const blob: any = await this.httpService.getBlob('report/downloadReflections?' + qs)

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${this.clientName}-reflections.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } finally {

    }
    return false
  }

  async selectAcademicYear(year) {

    if (!year) return;

    const ayear = this.academicYears.find(yearObject => yearObject.formatted_year == year)

    // ayear.start_date.date has start date object.

    // ayear.end_date.date has end date object.

    // set formControl values
    this.f.fromDate.setValue(ayear.start_date.date.toString().substring(0, 10))
    this.f.toDate.setValue(ayear.end_date.date.toString().substring(0, 10))

    // do the fetch

    await this.fetchData(ayear.start_date.date.toString().substring(0, 10), ayear.end_date.date.toString().substring(0, 10))
  }


  async fetchAcademicYears() {

    const res: any = await this.httpService.postAsync("report/academicYears", {})

    this.academicYears = res.academicYears
  }


  async ngOnInit() {

    const date = new Date();
    // Create the 1st of the current month
    const firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);

    // Format to YYYY-MM-DD using local values
    const firstOfMonthString = [
      firstOfMonth.getFullYear(),
      String(firstOfMonth.getMonth() + 1).padStart(2, '0'),
      '01'
    ].join('-');

    this.createSearchForm(firstOfMonthString)

    await this.fetchAcademicYears()


    this.displayedColumns = this.columnNames.map(x => x.id);
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.sort = this.sort;

    if (this.controller.getClients().length == 0) {
      await this.fetchClients()
    }

    this.route.queryParams.subscribe(async (params: Params) => {
      this.tagId = params['tagId'] ? +params['tagId'] : null;
      this.clientId = params['clientId'];
      if (this.tagId) {
        this.clientName = params['tag'] || 'Tag';
      } else {
        this.clientName = this.controller.getClientName(this.clientId) || "All";
      }

      await this.fetchData(firstOfMonthString, null)
    })
  }

  async fetchClients() {
    try {
      const clients: any = await this.httpService.postAsync("hclient/listClients", {})
      this.controller.setClients(clients)
    } catch (e) {
      // ignore
    }
  }

}
